module.exports = __webpack_public_path__ + "static/media/bg.b811a1f6.gif";